import React, { useEffect } from 'react';
import { isFunction } from 'lodash';

const useOnUnmount = (props) => {
  useEffect(() => {
    return () => {
      const { onUnmount } = props;
      if (isFunction(onUnmount)) onUnmount();
    };
  }, []);
};

export default useOnUnmount;
